module.exports = __webpack_public_path__ + "static/media/ferrari.0f17d3e6.png";